/**
 * 主题系统。
 *
 * 主题以 CSS 变量的形式注入到页面根节点，模板组件统一使用
 * `bg-[var(--c-bg)]` 这类写法，从而实现「一套布局、任意换肤」。
 */

export interface ThemeConfig {
  '--c-bg': string;
  '--c-bg-grad': string;
  '--c-surface': string;
  '--c-text': string;
  '--c-muted': string;
  '--c-accent': string;
  '--c-accent-soft': string;
  '--c-border': string;
  '--radius': string;
  '--font': string;
}

/** 默认主题（水墨素雅），接口未返回时的兜底 */
export const DEFAULT_THEME: ThemeConfig = {
  '--c-bg': '#faf9f7',
  '--c-bg-grad': '#f2f0ec',
  '--c-surface': '#ffffff',
  '--c-text': '#1c1917',
  '--c-muted': '#867c68',
  '--c-accent': '#d97706',
  '--c-accent-soft': '#ffd894',
  '--c-border': '#e3dfd7',
  '--radius': '16px',
  '--font': 'serif',
};

/**
 * 把主题配置转成 React 内联样式。
 * React 支持直接传入 CSS 自定义属性。
 */
export function themeToStyle(config?: Partial<ThemeConfig> | null): React.CSSProperties {
  const merged = { ...DEFAULT_THEME, ...(config ?? {}) };
  return merged as unknown as React.CSSProperties;
}

/** 常用语义化类名，避免每个模板重复写 var() */
export const T = {
  bg: 'bg-[var(--c-bg)]',
  bgGrad: 'bg-[var(--c-bg-grad)]',
  surface: 'bg-[var(--c-surface)]',
  text: 'text-[var(--c-text)]',
  muted: 'text-[var(--c-muted)]',
  accent: 'text-[var(--c-accent)]',
  accentBg: 'bg-[var(--c-accent)]',
  border: 'border-[var(--c-border)]',
} as const;
